export default __webpack_public_path__ + "static/media/template7.5a7c31ac.png";